module.exports = __webpack_public_path__ + "static/media/ocassole.be6bd967.jpg";